module.exports = __webpack_public_path__ + "img/blog-3.ec48c2db.jpg";